import { MaskModel } from "./model.interface";

export const polishPostalCode: MaskModel = {
    mask: [/\d/, /\d/, '-', /\d/, /\d/, /\d/],
    guide: true,
    keepCharPositions: true,
    showMask: true
  };